import React, { useRef } from "react";
import Slider from 'rc-slider';
import { debounce } from 'lodash';

const debounceTime = 250;

const ProcanvasSlider = ({ value, onChange, min, max, step, minLimit }) => {
  const debouncedOnChange = useRef(debounce((newValue) => {
    onChange(newValue, true);
  }, debounceTime));
  const handleOnChange = (newValue) => {
    let valueToUpdate = newValue;
    if (minLimit && newValue < minLimit) {
      valueToUpdate = minLimit;
    }
    if (valueToUpdate !== value) {
      onChange(valueToUpdate, false);
      debouncedOnChange.current(valueToUpdate);
    }
  };

  const currentPercent = (value / (max - min)) * 100;

  const dynamicMarks = { [min]: 'Min', [max]: max };
  if (currentPercent <= 7) {
    dynamicMarks[min] = ' ';
  } else if (currentPercent >= 93) {
    dynamicMarks[max] = ' ';
  }

  return (
    <Slider
      visible
      marks={ dynamicMarks }
      min={ min }
      max={ max }
      step={ step }
      value={ value }
      onChange={ handleOnChange }
    />
  );
};

export default ProcanvasSlider;
